<button
	class="ai-assistant-btn"
	type="button"
	(click)="openAssistant()"
	title="Andi: how-to and documentation help"
	aria-label="Andi: how-to and documentation help"
>
	<img class="ai-assistant-avatar" src="assets/img/andi/andi-avatar.png" alt="" />
</button>
